import React from 'react';
import { Box } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Close = function Close(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height;
  return /*#__PURE__*/_jsxs(Box, {
    as: "svg",
    $styles: {
      width: width,
      height: height
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M5 5L19 19",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "square",
      strokeLinejoin: "bevel"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19 5L5 19",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "square",
      strokeLinejoin: "bevel"
    })]
  });
};

export default Close;